import axios from 'axios';
import React, { Component } from 'react';
import { serviceUrl } from '../App';
import Message from '../utils/Message/Message';
import { ThemeContext } from './theme.context';
import { GetBackendUrlForGlobalFunctions } from '../App';
interface Props {}
interface IState {
  isLogin: boolean;
  isDarkMode: any;
  isChartOpen: any;
  toggleChart: any;
  isDataChangeSchedule: boolean;
  isDataChangeTrade: boolean;
  isDataChangeMaterials: boolean;
  isTabChangeMaterials: boolean;
  isDataChangeTeam: boolean;
  isDataChangeKpiTeam: boolean;
  isDataChangeKpiTrade: boolean;
  isDataChangeKpiTradePerson: boolean;
  isLoadAllowChange: boolean;
  isDataChangeKpiShift: boolean;
  isDataChangeShiftElement: boolean;
  isDataChangeAssignment: boolean;
  isDataChangeShiftTemplate: boolean;
  isChangeTabPane: boolean;
  allUsersData: any;
  isChangeCurrentTab: boolean;
  isChangeCurrentTabTask: boolean;
  changeCurrentContainerTabIndex?: number;
  currentTabTaskIndex?: number;
  isChanceCurrentTabEvent: boolean;
  currentTabEventIndex: number;
  isChanceCurrentEventID: boolean;
  currentEventID: number;
  isDataChangeWorkbench?: boolean;
  workbenchDateTimeValue: string;
  currentTabWorkbenchBottomIndex: number;
  isChangeCurrentTabWorkbenchBottom: boolean;
  isDataChangeWorkbenchBottomData: boolean;
  workbenchValueBottom: string;
  isDataChangeForTemplateWBData?: boolean;
  ForTemplateWBValue: number;
  isChangeTabForTemplateWB?: boolean;
  planId: number;
  isAttachmentsAllowChange: boolean;
  isMaterialAllowChange: boolean;
  isOperationsAllowChange: boolean;
  isWorkordersAllowChange: boolean;
  isKanbanAllowChange: boolean;
  isResourcesAllowChange: boolean;
  isHierarchyDone: boolean;
  timeZone: string;
  schedulerFetchRequest: boolean,
  setSchedulerFetchRequest: Function;
  quickScheduleDateOnLoad: Date;
  setQuickScheduleDateOnLoad: Function;
  isClickedQuickLoad:boolean;
  setIsClickedQuickLoad:Function;
  expandStatus:boolean;
  setExpandStatus:Function;
}
export default class GeneralContext extends Component<Props, IState> {
  constructor(prop: Props) {
    super(prop);
    this.state = {
      expandStatus:false,
      setExpandStatus:(value:boolean)=>{},
      isClickedQuickLoad:false,
      setIsClickedQuickLoad:(value: boolean) => {},
      quickScheduleDateOnLoad: new Date(),
      setQuickScheduleDateOnLoad: (value: Date) => {},
      schedulerFetchRequest: false,
      setSchedulerFetchRequest: (value: boolean) => {},
      isLogin: false,
      toggleChart: this.toggleChart,
      isDarkMode: true,
      isChartOpen: true,
      isDataChangeSchedule: false,
      isDataChangeTrade: false,
      isDataChangeTeam: false,
      isDataChangeKpiTeam: false,
      isDataChangeKpiShift: false,
      isDataChangeKpiTrade: false,
      isDataChangeKpiTradePerson: false,
      isDataChangeShiftElement: false,
      isDataChangeAssignment: false,
      isDataChangeShiftTemplate: false,
      isChangeTabPane: false,
      allUsersData: [],
      isChangeCurrentTab: false,
      isChangeCurrentTabTask: false,
      changeCurrentContainerTabIndex: -1,
      currentTabTaskIndex: -1,
      isChanceCurrentTabEvent: false,
      currentTabEventIndex: -1,
      currentEventID: -1,
      isChanceCurrentEventID: false,
      isDataChangeWorkbench: false,
      workbenchDateTimeValue: '',
      isChangeCurrentTabWorkbenchBottom: false,
      currentTabWorkbenchBottomIndex: -1,
      isDataChangeWorkbenchBottomData: false,
      workbenchValueBottom: '',
      ForTemplateWBValue: -1,
      isChangeTabForTemplateWB: false,
      isDataChangeForTemplateWBData: false,
      planId: 0,
      isLoadAllowChange: false,
      isDataChangeMaterials: false,
      isTabChangeMaterials: false,
      isAttachmentsAllowChange: false,
      isMaterialAllowChange: false,
      isOperationsAllowChange: false,
      isWorkordersAllowChange: false,
      isResourcesAllowChange: false,
      isHierarchyDone: false,
      isKanbanAllowChange: false,
      timeZone: '',
    };
  }
    setExpandStatus = (value: boolean) => {
        this.setState({ expandStatus: value });
    };
  setIsClickedQuickLoad = (value: boolean) => {
        this.setState({ isClickedQuickLoad: value });
    };
    setQuickScheduleDateOnLoad = (value: Date) => {
      this.setState({ quickScheduleDateOnLoad: value });
  };
    setSchedulerFetchRequest = (value: boolean) => {
        this.setState({ schedulerFetchRequest: value });
    };
    setDataChange = (value: boolean) => {
    this.setState({ isDataChangeSchedule: value });
  };
  setDataChangeTrade = (value: boolean) => {
    this.setState({ isDataChangeTrade: value });
  };
  setDataChangeMaterials = (value: boolean) => {
    this.setState({ isDataChangeMaterials: value });
  };
  setTabChangeMaterials = (value: boolean) => {
    this.setState({ isTabChangeMaterials: value });
  };
  setLoadAllowChange = (value: boolean) => {
    this.setState({ isLoadAllowChange: value });
  };
  setMaterialAllowChange = (value: boolean) => {
    this.setState({ isMaterialAllowChange: value });
  };
  setAttachmentsAllowChange = (value: boolean) => {
    this.setState({ isAttachmentsAllowChange: value });
  };
  setOperationsAllowChange = (value: boolean) => {
    this.setState({ isOperationsAllowChange: value });
  };
  setWorkordersAllowChange = (value: boolean) => {
    this.setState({ isWorkordersAllowChange: value });
  };
  setKanbanAllowChange = (value: boolean) => {
    this.setState({ isKanbanAllowChange: value });
  };
  setResourcesAllowChange = (value: boolean) => {
    this.setState({ isResourcesAllowChange: value });
  };
  setDataChangeTeam = (value: boolean) => {
    this.setState({ isDataChangeTeam: value });
  };
  setDataChangeKpiTeam = (value: boolean) => {
    this.setState({ isDataChangeKpiTeam: value });
  };
  setDataChangeWorkbench = (value: boolean, dateTime: any) => {
    this.setState({
      isDataChangeWorkbench: value,
      workbenchDateTimeValue: dateTime,
    });
  };
  setDataChangeWorkbenchBottomData = (value: boolean, dateTime: any) => {
    this.setState({
      isDataChangeWorkbenchBottomData: value,
      workbenchValueBottom: dateTime,
    });
  };
  setDataChangeKpiTrade = (value: boolean) => {
    this.setState({ isDataChangeKpiTrade: value });
  };
  setDataChangeKpiTradePerson = (value: boolean) => {
    this.setState({ isDataChangeKpiTradePerson: value });
  };
  setDataChangeKpiShift = (value: boolean) => {
    this.setState({ isDataChangeKpiShift: value });
  };
  setDataChangeShiftElement = (value: boolean) => {
    this.setState({ isDataChangeShiftElement: value });
  };
  setDataChangeAssignment = (value: boolean) => {
    this.setState({ isDataChangeAssignment: value });
  };
  setDataChangeShiftTemplate = (value: boolean) => {
    this.setState({ isDataChangeShiftTemplate: value });
  };
  setChangeTabPane = (value: boolean) => {
    this.setState({ isChangeTabPane: value });
  };
  setPlanId = (value: number) => {
    this.setState({ planId: value });
  };
  setChangeCurrentTab = (value: boolean, index: number) => {
    this.setState({
      isChangeCurrentTab: value,
      changeCurrentContainerTabIndex: index,
    });
  };

  setChangeTabForTemplateWB = (value: boolean, index: number) => {
    this.setState({
      isChangeTabForTemplateWB: value,
      ForTemplateWBValue: index,
    });
  };
  setDataChangeForTemplateWBData = (value: boolean) => {
    this.setState({ isDataChangeForTemplateWBData: value });
  };
  setChangeCurrentTabTask = (value: boolean, index: number) => {
    this.setState({
      isChangeCurrentTabTask: value,
      currentTabTaskIndex: index,
    });
  };
  setChangeCurrentTabEvent = (value: boolean, index: number) => {
    this.setState({
      isChanceCurrentTabEvent: value,
      currentTabEventIndex: index,
    });
  };
  setChangeCurrentTabWorkbenchBottom = (value: boolean, index: number) => {
    this.setState({
      isChangeCurrentTabWorkbenchBottom: value,
      currentTabWorkbenchBottomIndex: index,
    });
  };
  setChangeCurrentEventID = (value: boolean, index: number) => {
    this.setState({
      isChanceCurrentEventID: value,
      currentEventID: index,
    });
  };
  setHierarchyDone = (value: boolean) => {
    this.setState({
      isHierarchyDone: value,
    });
    axios
      .get(
        GetBackendUrlForGlobalFunctions() +
          `asset-hierarchy/generate_asset_hierarchy`
      )
      .then((res) => {
        if (res.data) {
          if (res.data) {
            Message.success('Task completed');
          } else {
            Message.error('Error');
          }
        } else {
          Message.error('Error');
        }
        this.setState({
          isHierarchyDone: false,
        });
      })
      .catch((er) => {
        this.setState({
          isHierarchyDone: false,
        });
        if (er.response) {
          Message.error(
            er.response.data +
              '\n' +
              er.response.status +
              '\n' +
              er.response.headers
          );
        } else if (er.request) {
          Message.error(er.request);
        } else {
          Message.error('Error: ' + er.message);
        }
      });
  };
  setTeamValue = (value: any) => {
    this.setState({ isDarkMode: value });
  };
  toggleChart() {
    this.setState({ isChartOpen: !this.state.isChartOpen });
  }
  render() {
    return (
      <ThemeContext.Provider
        value={{
          expandStatus: this.state.expandStatus,
          setExpandStatus: this.setExpandStatus,
          isClickedQuickLoad:this.state.isClickedQuickLoad,
          setIsClickedQuickLoad:this.setIsClickedQuickLoad,
          quickScheduleDateOnLoad: this.state.quickScheduleDateOnLoad,
          setQuickScheduleDateOnLoad: this.setQuickScheduleDateOnLoad,
          isDarkMode: this.state.isDarkMode,
          setTeamValue: this.setTeamValue,
          isChartOpen: this.state.isChartOpen,
          toggleChart: this.toggleChart,
          isDataChangeSchedule: this.state.isDataChangeSchedule,
          setDataChange: this.setDataChange.bind(this),
          isDataChangeTrade: this.state.isDataChangeTrade,
          setDataChangeTrade: this.setDataChangeTrade.bind(this),
          isDataChangeTeam: this.state.isDataChangeTeam,
          setDataChangeTeam: this.setDataChangeTeam.bind(this),
          isDataChangeKpiTeam: this.state.isDataChangeKpiTeam,
          setDataChangeKpiTeam: this.setDataChangeKpiTeam.bind(this),
          isDataChangeKpiTrade: this.state.isDataChangeKpiTrade,
          setDataChangeKpiTrade: this.setDataChangeKpiTrade.bind(this),
          isDataChangeKpiTradePerson: this.state.isDataChangeKpiTradePerson,
          setDataChangeKpiTradePerson:
            this.setDataChangeKpiTradePerson.bind(this),
          isDataChangeKpiShift: this.state.isDataChangeKpiShift,
          setDataChangeKpiShift: this.setDataChangeKpiShift.bind(this),
          isDataChangeShiftElement: this.state.isDataChangeShiftElement,
          setDataChangeShiftElement: this.setDataChangeShiftElement.bind(this),
          isDataChangeAssignment: this.state.isDataChangeAssignment,
          setDataChangeAssignment: this.setDataChangeAssignment.bind(this),
          isDataChangeShiftTemplate: this.state.isDataChangeShiftTemplate,
          setDataChangeShiftTemplate:
            this.setDataChangeShiftTemplate.bind(this),
          isChangeTabPane: this.state.isChangeTabPane,
          setChangeTabPane: this.setChangeTabPane.bind(this),
          isChangeCurrentTab: this.state.isChangeCurrentTab,
          setChangeCurrentTab: this.setChangeCurrentTab.bind(this),
          isChangeCurrentTabTask: this.state.isChangeCurrentTabTask,
          setChangeCurrentTabTask: this.setChangeCurrentTabTask.bind(this),
          changeCurrentContainerTabIndex:
            this.state.changeCurrentContainerTabIndex,
          currentTabTaskIndex: this.state.currentTabTaskIndex,
          setChangeCurrentTabEvent: this.setChangeCurrentTabEvent.bind(this),
          currentTabEventIndex: this.state.currentTabEventIndex,
          isChangeCurrentTabEvent: this.state.isChanceCurrentTabEvent,
          currentEventID: this.state.currentEventID,
          isChangeEventID: this.state.isChanceCurrentEventID,
          setChangeEventID: this.setChangeCurrentEventID.bind(this),
          setDataChangeWorkbench: this.setDataChangeWorkbench.bind(this),
          isDataChangeWorkbench: this.state.isDataChangeWorkbench,
          workbenchDateTimeValue: this.state.workbenchDateTimeValue,
          setChangeCurrentTabWorkbenchBottom:
            this.setChangeCurrentTabWorkbenchBottom.bind(this),
          currentTabWorkbenchBottomIndex:
            this.state.currentTabWorkbenchBottomIndex,
          isChangeCurrentTabWorkbenchBottom:
            this.state.isChangeCurrentTabWorkbenchBottom,
          setDataChangeWorkbenchBottomData:
            this.setDataChangeWorkbenchBottomData.bind(this),
          isDataChangeWorkbenchBottomData:
            this.state.isDataChangeWorkbenchBottomData,
          workbenchValueBottom: this.state.workbenchValueBottom,
          ForTemplateWBValue: this.state.ForTemplateWBValue,
          setChangeTabForTemplateWB: this.setChangeTabForTemplateWB.bind(this),
          setDataChangeForTemplateWBData:
            this.setDataChangeForTemplateWBData.bind(this),
          isChangeTabForTemplateWB: this.state.isChangeTabForTemplateWB,
          isDataChangeForTemplateWBData:
            this.state.isDataChangeForTemplateWBData,
          planId: this.state.planId,
          setPlanId: this.setPlanId.bind(this),
          isLoadAllowChange: this.state.isLoadAllowChange,
          setLoadAllowChange: this.setLoadAllowChange.bind(this),
          setDataChangeMaterials: this.setDataChangeMaterials.bind(this),
          isDataChangeMaterials: this.state.isDataChangeMaterials,
          isTabChangeMaterials: this.state.isTabChangeMaterials,
          setTabChangeMaterials: this.setTabChangeMaterials.bind(this),
          isAttachmentsAllowChange: this.state.isAttachmentsAllowChange,
          isMaterialAllowChange: this.state.isMaterialAllowChange,
          setAttachmentsAllowChange: this.setAttachmentsAllowChange.bind(this),
          setMaterialAllowChange: this.setMaterialAllowChange.bind(this),
          isOperationsAllowChange: this.state.isOperationsAllowChange,
          isWorkordersAllowChange: this.state.isWorkordersAllowChange,
          setOperationsAllowChange: this.setOperationsAllowChange.bind(this),
          setWorkordersAllowChange: this.setWorkordersAllowChange.bind(this),
          isResourcesAllowChange: this.state.isResourcesAllowChange,
          setResourcesAllowChange: this.setResourcesAllowChange.bind(this),
          isHierarchyDone: this.state.isHierarchyDone,
          setHierarchyDone: this.setHierarchyDone.bind(this),
          isKanbanAllowChange: this.state.isKanbanAllowChange,
          setKanbanAllowChange: this.setKanbanAllowChange.bind(this),
          timeZone: this.state.timeZone,
          setTimezone: (args: string) => this.setState({ timeZone: args }),
          schedulerFetchRequest:  this.state.schedulerFetchRequest,
          setSchedulerFetchRequest: this.setSchedulerFetchRequest.bind(this),
        }}
      >
        {this.props.children}
      </ThemeContext.Provider>
    );
  }
}
